import Container from '@mui/material/Container';
import type { LoaderArgs } from '@remix-run/node';
import { json } from '@remix-run/node';
import { Outlet, useMatches } from '@remix-run/react';
import * as React from 'react';
import Cart, { cartWidth } from '~/components/Cart';
import Footer from '~/components/Footer';
import Navbar from '~/components/Navbar';
import type { Cart as TCart } from '~/services/api.server';
import { scApi } from '~/services/api.server';
import { getUpdatedAuthentication } from '~/services/auth.server';
import { getSession } from '~/services/session.server';

export async function loader({ request }: LoaderArgs) {
  const [{ user }, session] = await Promise.all([getUpdatedAuthentication(request), getSession(request)]);
  const accountId = session.get('accountId');

  if (user) {
    return json({ user: await scApi.getMe(user.accessToken, accountId) });
  }

  return json({ user: null });
}

export default function Contained() {
  const [navbarHeight, setNavbarHeight] = React.useState<number>(73);
  React.useEffect(() => {
    setNavbarHeight(document.getElementById('navbar')?.offsetHeight || 73);
  }, []);

  const isShop = useMatches().some((match) => match.id.includes('shop') && !match.id.includes('$productSlug'));
  const { designLabQueueQty }: { designLabQueueQty: number } = useMatches()[0].data;

  const { cart }: { cart: TCart } = useMatches()[0].data;
  const [openCart, setOpenCart] = React.useState(false);

  return (
    <>
      <Navbar openCart={openCart} setOpenCart={setOpenCart} designLabQueueQty={designLabQueueQty} />
      <Container
        maxWidth={isShop ? false : 'lg'}
        sx={[
          {
            mb: 10,
            pt: { xs: `${navbarHeight}px`, md: `${navbarHeight + 24}px` },
            ...(isShop ? { px: { xs: 0, md: 4 }, maxWidth: '1440px' } : null),
          },
          openCart && { width: { md: `calc(100vw - ${cartWidth}px)`, xl: '100%' } },
        ]}
      >
        <Outlet />
      </Container>
      <Footer />
      <Cart cart={cart} open={openCart} setOpenCart={setOpenCart} />
    </>
  );
}
